// dashboardRoutes.js
import React from "react";
import Error from "../utils/Error";
import {
  Dashboard,
  Client,
  ServiceChargeEdit,
  Contract,
  ContractSingleView,
  JobPosition,
  Nationality,
  Notes,
  Profile,
  Project,
  Quotation,
  QuotationCostNotes,
  QuotationCostSheet,
  QuotationCostTermsAndCondition,
  RateCategory,
  RecruitmentAgency,
  Roles,
  Sector,
  Source,
  Templates,
  TemplatesNotes,
  TemplatesTermsAndCondition,
  TermsAndCondition,
  Users,
  VisaProviders,
  VisaReport,
  PassportRenewal,
  //OPS 2
  BorderNumber,
  OnArrivalMedical,
  Insurance,
  Sadaad,
  Absher,
  Iqama,
  AtmPayroll,
  QiwaContract,
  DrivingLicence,
  VisProfessionChanges,
  Nakalakafala,
  Baladiya,
  Ajeer,
  MasterDataBase,
  // Fin
  FinInsurance,
  FinOnArrivalMedical,
  FinNakalaKafala,
  FinSadaad,
  FinDrivingLicence,
  FinAjeer,
  FinBaladiya,
  FinAtmPayRoll,
  FinPassportRenewal,
  FinPayRoll,
  FinVisaProfessionChanges,
  GRAjeer,
  Mobilization,
  Demobilization,
  Remobilization,
  FinalExit,
  FinalExitDetails,
  SettlementPreviewDetails,
  LocalFinalExit,
} from "../modules/Dashboard";
import FinalExitDetailsPage from "../modules/Dashboard/components/FinalExit/FinalExitDetailsPage";

import VisaProfession from "../modules/Dashboard/components/VisaProfession/VisaProfession";
import CheckAccess from "./checkAccessLayout";
import GRVRF from "../modules/Dashboard/components/GR/VRF/GRVRF";
import VRFFinance from "../modules/Dashboard/components/Finance/VRF/VRFFinance";
import VrfPaymentConfirm from "../modules/Dashboard/components/Finance/VRF/VrfPaymentConfirm";
import Payments from "../modules/Dashboard/components/Finance/Payments/Payments";
import GlobalArrivalNotification from "../modules/Dashboard/components/GlobalArrivalNotification/GlobalArrivalNotification";
import ArrivalCandidates from "../modules/Dashboard/components/GlobalArrivalNotification/ArrivalCandidates";
import ProjectSingleView from "../modules/Dashboard/components/Project/ProjectSingleView";
import ProjectOverview from "../modules/Dashboard/components/Project/ProjectSections/Overview";
import ProjectJobEnquiry from "../modules/Dashboard/components/Project/ProjectSections/JobEnquiry/JobEnquiry";
import DownloadLoader from "../modules/Dashboard/components/GlobalArrivalNotification/PdfDownload/DownloadLoader";
import DummyPdfs from "../modules/Dashboard/DummyPdfs/DummyPdfs";
import ProfessionLevelAndFee from "../modules/Dashboard/components/ProfessionLevelAndFees/ProfessionLevelAndFee";
import InsuranceCompany from "../modules/Dashboard/components/InsuranceCompany/InsuranceCompany";
import CostSheetAddNew from "../modules/Dashboard/components/Quotation/QuotationCostSheet/CostSheetAddNew";
import EditFeesAndMuqeem from "../modules/Dashboard/components/Quotation/QuotationCostSheet/EditFeesAndMuqeem/EditFeesAndMuqeem";
import ContractCostSheetAddNew from "../modules/Dashboard/components/Contract/ContractSingleView/CostSheet/AddProfession/CostSheetAddNew";
import ContractCostSheetNotes from "../modules/Dashboard/components/Contract/ContractSingleView/CostSheet/Notes/Notes";
import ContractCostSheetTerms from "../modules/Dashboard/components/Contract/ContractSingleView/CostSheet/Terms/Terms";
import ContractCostSheetEdit from "./../modules/Dashboard/components/Contract/ContractSingleView/CostSheet/Edit/CostSheetEdit";
import EditFeesAndMuqeemContract from "../modules/Dashboard/components/Contract/ContractSingleView/CostSheet/EditFeesAndMuqeem/EditFeesAndMuqeemContract";
import ProjectRecAgency from "../modules/Dashboard/components/Project/ProjectSections/RecAgency/RecAgency";
import ProjectJobOrder from "../modules/Dashboard/components/Project/ProjectSections/JobOrder/JobOrder.jsx";
import ProjectCandidateList from "./../modules/Dashboard/components/Project/ProjectSections/CandidateList/CandidateList";
import CandidateListUpdateVisaDetails from "../modules/Dashboard/components/Project/ProjectSections/CandidateList/sections/UpdateVisaDetails/UpdateVisaDetails.js";
import UpdateFlightDetails from "../modules/Dashboard/components/Project/ProjectSections/CandidateList/sections/UpdateFlightDetails/UpdateFlightDetails.jsx";
import Candidate from "../modules/Dashboard/components/Candidates/Candidate.js";
import ArrivalOnboarding from "../modules/Dashboard/components/ArrivalOnboarding/ArrivalOnboarding.js";
import VisaRequestData from "../modules/Dashboard/components/VRF_Visa/VisaRequest.js";
import VisaRequestsummary from "../modules/Dashboard/components/VRF_Visa/visaRequestSummary.js";
import CreateVRF from "../modules/Dashboard/components/VRF_Visa/createVisaRequestForm.js";
import Grdesk from "../modules/Dashboard/components/VRF_Visa/grDesk_listview.js";
import VrrIndex from "../modules/Dashboard/components/financeDesk/vrrindex.js";
import VisaStockNew from "../modules/Dashboard/components/visaStock_New/visaStockNew.js";
import VisaAllocation from "../modules/Dashboard/components/VisaAllocation/visaallocation.js";
import VisaReturn from "../modules/Dashboard/components/VisaReturnRequest/Visareturnmain.js";
import Grdeskreturnrequest from "../modules/Dashboard/components/VisaReturnRequest/VisareturnByGrdesk.js";
import VisaReturnbyfinance from "../modules/Dashboard/components/VisaReturnRequest/visaReturnbyFinance.js";
import VisareturnbyOps from "../modules/Dashboard/components/VisaReturnRequest/visareturnByOps.js";
import Visastockdetails from "../modules/Dashboard/components/visaStock_New/visaStockdetailslistView.js";
import Ops1masterDatabase from "../modules/Dashboard/components/Ops_1_master_database/ops_1_mainlist.js";
import Addlocaltransfer from "../modules/Dashboard/components/Ops_1_master_database/addLocaltransfer.js";
import VisaCostedit from "../modules/Dashboard/components/Visacost&securityDeposite/visacostedit.js";
import Visacostandsecdeposite from "../modules/Dashboard/components/Visacost&securityDeposite/visaCostmain.js";
// import VisProfessionChanges from "../modules/Dashboard/components/VisaProfessionChanges/VisaProfessionChanges.js";
import Employeeloanadvance from "../modules/Dashboard/components/employee_loan_Advance/employeeloanAdvancemain.js";
import InvoiceCostPlus from "../modules/Dashboard/components/invoiceCostPlus/invoiceCostPlusmain.js";
import GenereteInvoice from "../modules/Dashboard/components/invoiceCostPlus/generateInvoice.js";
import EditvisaRequest from "../modules/Dashboard/components/VRF_Visa/edit_visa_requestform.js";
import InvoiceEdit from "../modules/Dashboard/components/invoiceCostPlus/invoiceEdit.js";
// import FinPassportRenewal from "../modules/Dashboard/components/FinPassportRenewal/FinPassportRenewal.js";
import DependentMaster from "../modules/Dashboard/components/WorkFlowDependentMaster/DependentMaster.js";
import InsuranceDependent from "../modules/Dashboard/components/WorkFlowInsuranceDependent/InsuranceDependent.js";
import DependentAddition from "../modules/Dashboard/components/WorkFlowDependentAddition/DependentAddition.js";
import DependentPayment from "../modules/Dashboard/components/FINANCE_DESK_DEPENDENT_PAYMENT/dependentPayment.js";
// import Mobilization from "../modules/Dashboard/components/Mobilization/Mobilizationmain.js";
// import Demobilization from "../modules/Dashboard/components/Demobilization/Demobilization.js";
import VisacostOnarrivalMain from "../modules/Dashboard/components/visacost&secDeposite-OnArrival/visaIndex.js";
import Employeeseclist from "../modules/Dashboard/components/visacost&secDeposite-OnArrival/Editemployeelist.js";
import Financedemobilize from "../modules/Dashboard/components/Demobilization_finance/finance_main.js";
import ApplyInsurance_InsuranceDependent from "../modules/Dashboard/components/WorkFlowInsuranceDependent/ApplyInsurance_InsuranceDependent.js";
import OPS1_InsuranceDependent from "../modules/Dashboard/components/WorkFlowInsuranceDependent/OPS1_InsuranceDependent.js";
import Dependentaddition_OPS2 from "../modules/Dashboard/components/Dependent_Addition_New/dependent_addition_ops2.js";
import DependentAddition_ops1 from "../modules/Dashboard/components/Dependent_Addition_New/dependent_addition_ops1.js";
import Dependent_Addition_Ops2_Edit from "../modules/Dashboard/components/Dependent_Addition_New/dependent_addition_ops2_edit.js";
import Dependent_addition_ops1_Edit from "../modules/Dashboard/components/Dependent_Addition_New/dependent_addition_ops1_edit.js";
import Finance_Dependent from "../modules/Dashboard/components/Dependent_Addition_New/dependent_addition_finance.js";
import Addition_Apporval_edit from "../modules/Dashboard/components/Dependent_Addition_New/Addition_apporval_edit.js";
import QiwaContract_OPS from "../modules/Dashboard/components/Qiwa_contract_OPS/QiwaContract.js";

const dashboardRoutes = [
  { path: "download", element: <DownloadLoader /> },
  {
    path: "/dashboard",
    element: <Dashboard />,
    errorElement: <Error />,
    children: [
      {
        path: "edit-profile",
        element: (
          <CheckAccess module="Dashboard" name="profile-update">
            <Profile />
          </CheckAccess>
        ),
      },
      {
        path: "edit-profile",
        element: (
          <CheckAccess module="Dashboard" name="profile-update">
            <Profile />
          </CheckAccess>
        ),
      },
      {
        path: "Service-Charge-Edit",
        element: (
          <CheckAccess module="Client" name="client-create">
            <ServiceChargeEdit />
          </CheckAccess>
        ),
      },

      {
        path: "client",
        element: (
          <CheckAccess module="Client" name="client-list">
            <Client />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Client" name="client-create">
                <Client />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Client" name="client-edit">
                <Client />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "OPS 2",
        element: (
          <CheckAccess module="Client" name="client-create">
            <ServiceChargeEdit />
          </CheckAccess>
        ),
      },
      {
        path: "ops-1-master-database",
        element: (
          <CheckAccess
            module="OPS1 MASTER DATABASE"
            name="ops1-master-database-view"
          >
            <Ops1masterDatabase />
          </CheckAccess>
        ),
        children: [
          {
            path: "create-local-transfer",
            element: <Addlocaltransfer />,
          },
        ],
      },
      {
        path: "loan-advance",
        element: <Employeeloanadvance />,
      },
      {
        path: "invoice-cost-plus",
        element: <InvoiceCostPlus />,
        children: [
          {
            path: "generate-invoice",
            element: <GenereteInvoice />,
          },
          {
            path: "Edit-invoice-batch",
            element: <InvoiceEdit />,
          },
        ],
      },
      {
        path: "Visa-cost-&-sec-deposit",
        element: <Visacostandsecdeposite />,
        children: [
          {
            path: "summary",
            element: <VisaCostedit />,
          },
          {
            path: "summary-OnArrival",
            element: <VisacostOnarrivalMain />,
          },
          {
            path: "summary-OnArrival-editEmployee",
            element: <Employeeseclist />,
          },
        ],
      },
      {
        path: "visa-request-form",
        element: (
          <CheckAccess module="VISA REQUEST FORM" name="visa-request-form-view">
            <VisaRequestData />
          </CheckAccess>
        ),
        children: [
          {
            path: "ops-1-summary",
            element: (
              <CheckAccess module="VISA REQUEST FORM" name="visa-request-form-view">
                <VisaRequestsummary />
              </CheckAccess>
            ),
          },
          {
            path: "create-vrf",
            element: (
              <CheckAccess module="VISA REQUEST FORM" name="visa-request-form-create">
                <CreateVRF />
              </CheckAccess>
            ),
          },
          {
            path: "edit-draft-vrf",
            element: (
              <CheckAccess module="VISA REQUEST FORM" name="visa-request-form-edit">
                <EditvisaRequest />
              </CheckAccess>
            ),
          },
          {
            path: "Gr-desk",
            element: <Grdesk titles={["S.No", "VRF REFERENCE NO", "VISA PROVIDER", "AJEER", "SPONSOR ID", "NATIONALITY", "STAMP CITY", "VISA PROFESSION", "PRIORITY OF ISSUANCE", "TOTAL VISAS", "STATUS", "ACTION"]} />,
          },
          {
            path: "gr-desk-summary",
            element: <Grdesk />,
          },
        ],
      },
      {
        path: "Visa-return-request",
        element: (
          <CheckAccess module="VISA RETURN REQUEST" name="visa-return-request-view">
            <VisaReturn />
          </CheckAccess>
        ),
        children: [
          {
            path: "Gr-desk",
            element: (
              <CheckAccess module="VISA RETURN REQUEST" name="visa-return-request-view">
                <Grdeskreturnrequest />
              </CheckAccess>
            ),
          },
          {
            path: "Finance-desk",
            element: (
              <CheckAccess module="VISA RETURN REQUEST" name="visa-return-request-view">
                <VisaReturnbyfinance />
              </CheckAccess>
            ),
          },
          {
            path: "Ops-desk",
            element: (
              <CheckAccess module="VISA RETURN REQUEST" name="visa-return-request-view">
                <VisareturnbyOps />
              </CheckAccess>
            ),
          },
        ],
      },

      {
        path: "Border Number",
        element: (
          <CheckAccess module="BORDER NUMBER" name="border-number-view">
            <BorderNumber />
          </CheckAccess>
        ),
      },
      {
        path: "vrr-payment",
        element: <VrrIndex />,
      },
      {
        path: "Visa-Allocation",
        element: <VisaAllocation />,
      },

      {
        path: "nationality",
        element: (
          <CheckAccess module="Nationality" name="nationality-list">
            <Nationality />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Nationality" name="nationality-create">
                <Nationality />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Nationality" name="nationality-edit">
                <Nationality />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "rate-category",
        element: (
          <CheckAccess module="Rate Category" name="rate-category-list">
            <RateCategory />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Rate Category" name="rate-category-list">
                <RateCategory />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "rate-category/:categoryId",
        element: (
          <CheckAccess module="Rate Category" name="rate-category-item-list">
            <RateCategory />
          </CheckAccess>
        ),
      },
      {
        path: "rate-category/:categoryId/edit/:id",
        element: (
          <CheckAccess module="Rate Category" name="rate-category-item-edit">
            <RateCategory />
          </CheckAccess>
        ),
      },

      {
        path: "quotation",
        element: (
          <CheckAccess module="Quotation" name="quotation-list">
            <Quotation />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Quotation" name="quotation-create">
                <Quotation />
              </CheckAccess>
            ),
          },
          {
            path: "view",
            element: (
              <CheckAccess module="Quotation" name="quotation-list">
                <Quotation />
              </CheckAccess>
            ),
          },
          {
            path: "edit-quotation/:id",
            element: (
              <CheckAccess module="Quotation" name="quotation-edit">
                <Quotation />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "quotation/:quotationId",
        element: (
          <CheckAccess module="Quotation" name="quotation-cost-sheet-list">
            <QuotationCostSheet />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess
                module="Quotation"
                name="quotation-cost-sheet-create"
              >
                <CostSheetAddNew />
              </CheckAccess>
            ),
          },
          {
            path: "edit-fees-muqeem",
            element: (
              <CheckAccess
                module="Quotation"
                name="quotation-cost-sheet-edit"
              >
                <EditFeesAndMuqeem />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Quotation" name="quotation-cost-sheet-edit">
                <QuotationCostSheet />
              </CheckAccess>
            ),
          },
          {
            path: "terms",
            element: (
              <CheckAccess module="Quotation" name="quotation-cost-sheet-list">
                <QuotationCostTermsAndCondition />
              </CheckAccess>
            ),
            children: [
              {
                path: "create",
                element: (
                  <CheckAccess
                    module="Quotation"
                    name="quotation-cost-sheet-create"
                  >
                    <QuotationCostTermsAndCondition />
                  </CheckAccess>
                ),
              },
            ],
          },
          {
            path: "notes",
            element: <QuotationCostNotes />,
            children: [{ path: "create", element: <QuotationCostNotes /> }],
          },
        ],
      },
      {
        path: "notes",
        element: (
          <CheckAccess module="Notes" name="note-list">
            <Notes />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Notes" name="note-create">
                <Notes />
              </CheckAccess>
            ),
          },
          {
            path: "edit-notes/:id",
            element: (
              <CheckAccess module="Notes" name="note-edit">
                <Notes />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "visa-providers",
        element: (
          <CheckAccess module="Company" name="company-list">
            <VisaProviders />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Company" name="company-create">
                <VisaProviders />
              </CheckAccess>
            ),
          },
          {
            path: "edit-visa-providers/:id",
            element: (
              <CheckAccess module="Company" name="company-edit">
                <VisaProviders />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "visa-profession",
        element: (
          <CheckAccess
            module="VISA / IQAMA PROFESSION"
            name="visa-iqama-profession-view"
          >
            <VisaProfession />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess
                module="VISA / IQAMA PROFESSION"
                name="visa-iqama-profession-create"
              >
                <VisaProfession />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "visa-stock",
        element: (
          <CheckAccess module="VISA STOCK" name="visa-stock-view">
            <VisaStockNew />
          </CheckAccess>
        ),
      },
      {
        path: "visa-stock-details",
        element: (
          <CheckAccess module="VISA STOCK" name="visa-stock-view">
            <Visastockdetails />
          </CheckAccess>
        ),
      },
      {
        path: "actual-profession",
        element: (
          <CheckAccess module="Job Position" name="job-position-list">
            <JobPosition />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Job Position" name="job-position-create">
                <JobPosition />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Job Position" name="job-position-edit">
                <JobPosition />
              </CheckAccess>
            ),
          },
        ],
      },

      {
        path: "gr-vrf",
        element: (
          <CheckAccess module="Job Position" name="job-position-list">
            <GRVRF />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Job Position" name="job-position-create">
                <GRVRF />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Job Position" name="job-position-edit">
                <GRVRF />
              </CheckAccess>
            ),
          },
        ],
      },

      {
        path: "terms-and-condition",
        element: (
          <CheckAccess
            module="Terms And Condition"
            name="terms-and-conditions-list"
          >
            <TermsAndCondition />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess
                module="Terms And Condition"
                name="terms-and-conditions-create"
              >
                <TermsAndCondition />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess
                module="Terms And Condition"
                name="terms-and-conditions-edit"
              >
                <TermsAndCondition />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "users",
        element: (
          <CheckAccess module="User" name="user-list">
            <Users />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="User" name="user-create">
                <Users />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="User" name="user-edit">
                <Users />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "roles-and-permission",
        element: (
          <CheckAccess module="Roles and Permissions" name="role-list">
            <Roles />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Roles and Permissions" name="role-create">
                <Roles />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Roles and Permissions" name="role-edit">
                <Roles />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "templates",
        element: <Templates />,
        // loader: dashboardLoader,
        children: [
          { path: "create", element: <Templates /> },
          { path: "view", element: <Templates /> },
          { path: "edit-templates/:id", element: <Templates /> },
        ],
      },
      {
        path: "templates/:templateId",
        element: <Templates />,
        // loader: dashboardLoader,
        children: [
          {
            path: "terms",
            element: <TemplatesTermsAndCondition />,
            children: [
              { path: "create", element: <TemplatesTermsAndCondition /> },
              { path: "edit/:id", element: <TemplatesTermsAndCondition /> },
            ],
          },
          {
            path: "notes",
            element: <TemplatesNotes />,
            children: [{ path: "create", element: <TemplatesNotes /> }],
          },
        ],
      },
      {
        path: "contract",
        element: (
          <CheckAccess module="Contract" name="contract-list">
            <Contract />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Contract" name="contract-create">
                <Contract />
              </CheckAccess>
            ),
          },
          {
            path: "view",
            element: (
              <CheckAccess module="Contract" name="contract-list">
                <Contract />
              </CheckAccess>
            ),
          },
          {
            path: "edit-contract/:id",
            element: (
              <CheckAccess module="Contract" name="contract-edit">
                <Contract />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "contract/:contractId",
        element: (
          <CheckAccess module="Contract" name="contract-list">
            <ContractSingleView />
          </CheckAccess>
        ),
        children: [
          {
            path: "cost-sheet-edit/:costSheetId",
            element: <ContractCostSheetEdit />,
          },
          {
            path: "cost-sheet-edit-fees-muqeem",
            // element: <ContractCPCostSheetEdit />,
            element: <EditFeesAndMuqeemContract />,
          },
        ],
      },
      {
        path: "contract/:contractId/notes",
        element: <ContractCostSheetNotes />,
      },
      {
        path: "contract/:contractId/notes/create",
        element: <ContractCostSheetNotes />,
      },
      {
        path: "contract/:contractId/notes/edit/:notesId",
        element: <ContractCostSheetNotes />,
      },
      {
        path: "contract/:contractId/terms",
        element: <ContractCostSheetTerms />,
      },
      {
        path: "contract/:contractId/terms/create",
        element: <ContractCostSheetTerms />,
      },
      {
        path: "contract/:contractId/terms/edit/:termsId",
        element: <ContractCostSheetTerms />,
      },
      {
        path: "contract/:contractId/cost-sheet-addnew/:quotationId",
        element: <ContractCostSheetAddNew />,
      },
      {
        path: "project",
        element: (
          <CheckAccess module="Project" name="project-list">
            <Project />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Project" name="project-create">
                <Project />
              </CheckAccess>
            ),
          },
          {
            path: "view",
            element: (
              <CheckAccess module="Project" name="project-list">
                <Project />
              </CheckAccess>
            ),
          },
          {
            path: "edit-contract/:id",
            element: (
              <CheckAccess module="Project" name="project-edit">
                <Project />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "project/:projectId",
        element: (
          <CheckAccess module="Project" name="project-list">
            <ProjectSingleView />
          </CheckAccess>
        ),
        children: [
          {
            path: "overview",
            element: <ProjectOverview />,
          },
          {
            path: "job-enquiry",
            element: <ProjectJobEnquiry />,
            children: [
              {
                path: "create",
                element: <ProjectJobEnquiry />,
              },
              {
                path: "edit",
                element: <ProjectJobEnquiry />,
              },
            ],
          },
          {
            path: "rec-agency",
            element: <ProjectRecAgency />,
            children: [
              {
                path: "create",
                element: <ProjectRecAgency />,
              },
              {
                path: "edit",
                element: <ProjectRecAgency />,
              },
            ],
          },
          {
            path: "job-order",
            element: <ProjectJobOrder />,
          },
          {
            path: "candidate-list",
            element: <ProjectCandidateList />,
            children: [
              {
                path: "update-visa-details",
                element: <CandidateListUpdateVisaDetails />,
              },
              {
                path: "update-flight-details",
                element: <UpdateFlightDetails />,
              },
            ],
          },
        ],
      },
      {
        path: "source",
        element: (
          <CheckAccess module="Source" name="source-list">
            <Source />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Source" name="source-create">
                <Source />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Source" name="source-edit">
                <Source />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "sector",
        element: (
          <CheckAccess module="Sector" name="sector-list">
            <Sector />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Sector" name="sector-create">
                <Sector />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Sector" name="sector-edit">
                <Sector />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "recruitment-agency",
        element: (
          <CheckAccess module="Vendor" name="vendor-list">
            <RecruitmentAgency />
          </CheckAccess>
        ),
        children: [
          {
            path: "create",
            element: (
              <CheckAccess module="Vendor" name="vendor-create">
                <RecruitmentAgency />
              </CheckAccess>
            ),
          },
          {
            path: "edit/:id",
            element: (
              <CheckAccess module="Vendor" name="vendor-edit">
                <RecruitmentAgency />
              </CheckAccess>
            ),
          },
        ],
      },
      {
        path: "profession-levels-&-fees",
        element: (
          <CheckAccess
            module="PROFESSION LEVELS"
            name="profession-levels-view"
          >
            <ProfessionLevelAndFee />
          </CheckAccess>
        ),
      },
      {
        path: "finance/vrf",
        element: <VRFFinance />,
      },
      {
        path: "finance/vrf/confirm-payment",
        element: <VrfPaymentConfirm />,
      },
      {
        path: "finance/payments",
        element: <Payments />,
      },
      {
        path: "visa-report",
        element: <VisaReport />,
      },
      {
        path: "arrival-notification",
        element: <GlobalArrivalNotification />,
        children: [
          {
            path: ":arrivalId/candidates",
            element: <ArrivalCandidates />,
          },
        ],
      },
      {
        path: "candidates",
        element: <Candidate />,
      },
      {
        path: "dummy-pdfs",
        element: <DummyPdfs />,
      },
      {
        path: "insurance-company",
        element: (
          <CheckAccess
            module="INSURANCE COMPANY"
            name="insurance-company-view"
          >
            <InsuranceCompany />
          </CheckAccess>
        ),
      },
      {
        path: "arrival-onboarding",
        element: (
          <CheckAccess module="ARRIVAL / ONBOARDING" name="arrival-onboarding-view">
            <ArrivalOnboarding />
          </CheckAccess>
        ),
      },
      {
        path: "ops-2-master-database",
        element: <MasterDataBase />,
      },

      //Master DataBase Tab List
      {
        path: "border-number",
        element: (
          <CheckAccess module="Client" name="client-create">
            <BorderNumber />
          </CheckAccess>
        ),
      },
      {
        path: "On-arrival-medical",
        element: (
          <CheckAccess module="ON ARRIVAL MEDICAL" name="on-arrival-medical-view">
            <OnArrivalMedical />
          </CheckAccess>
        ),
      },
      {
        path: "Insurance",
        element: (
          <CheckAccess module="INSURANCE" name="insurance-view">
            <Insurance />
          </CheckAccess>
        ),
      },
      {
        path: "Sadaad",
        element: (
          <CheckAccess module="SADAAD" name="sadad-view">
            <Sadaad />
          </CheckAccess>
        ),
      },
      {
        path: "Iqama",
        element: (
          <CheckAccess module="IQAMA" name="iqama-update-list-view">
            <Iqama />
          </CheckAccess>
        ),
      },
      {
        path: "absher",
        element: (
          <CheckAccess module="ABSHER" name="absher-view">
            <Absher />
          </CheckAccess>
        ),
      },

      {
        path: "MasterDataBase",
        element: (
          <CheckAccess module="ops 2" name="">
            <MasterDataBase />
          </CheckAccess>
        ),
      },
      {
        path: "Atm-payroll",
        element: (
          <CheckAccess module="ATM / PAYROLL" name="atm-payroll-view">
            <AtmPayroll />
          </CheckAccess>
        ),
      },
      {
        path: "Qiwa-contract",
        element: (
          <CheckAccess module="QIWA CONTRACT" name="qiwa-contract-view">
            <QiwaContract />
          </CheckAccess>
        ),
      },

      {
        path: "QIWA-CONTRACT-OPS",
        element: (
          <CheckAccess module="QIWA CONTRACT" name="qiwa-contract-view">
            <QiwaContract_OPS />
          </CheckAccess>
        ),
      },

      {
        path: "Ajeer",
        element: (
          <CheckAccess module="AJEER" name="ajeer-update-view">
            <Ajeer />
          </CheckAccess>
        ),
      },
      {
        path: "Baladiya",
        element: (
          <CheckAccess module="BALADIYA" name="baladiya-update-view">
            <Baladiya />
          </CheckAccess>
        ),
      },

      {
        path: "Driving-licence",
        element: (
          <CheckAccess module="DRIVING LICENSE" name="driving-license-update-view">
            <DrivingLicence />
          </CheckAccess>
        ),
      },
      {
        path: "visa-profession-changes",
        element: (
          <CheckAccess module="VISA PROFESSION CHANGE" name="visa-profession-change-view">
            <VisProfessionChanges />
          </CheckAccess>
        ),
      },
      {
        path: "nakal-kafala",
        element: (
          <CheckAccess module="NAKAL KAFALA" name="nakal-kafala-view">
            <Nakalakafala />
          </CheckAccess>
        ),
      },

      {
        path: "Service-charge-edit",
        element: (
          <CheckAccess module="SERVICE CHARGE EDIT" name="service-charge-edit-view">
            <ServiceChargeEdit />
          </CheckAccess>
        ),
      },
      {
        path: "Passport-Renewal",
        element: (
          <CheckAccess module="PASSPORT RENEWAL" name="passport-renewal-view">
            <PassportRenewal />
          </CheckAccess>
        ),
      },

      //Master DataBase Tab List
      {
        path: "fin-insurance",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinInsurance />
          </CheckAccess>
        ),
      },

      {
        path: "fin-On-arrival-medical",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinOnArrivalMedical />
          </CheckAccess>
        ),
      },

      //sadaad Tab here

      {
        path: "fin-atm-payRoll",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinAtmPayRoll />
          </CheckAccess>
        ),
      },

      {
        path: "fin-payRoll-category",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinPayRoll />
          </CheckAccess>
        ),
      },

      // FinVisProfessionChanges
      {
        path: "fin-visa-profession-changes",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinVisaProfessionChanges />
          </CheckAccess>
        ),
      },
      // FinNakalaKafala
      {
        path: "fin-nakal-Kafala",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinNakalaKafala />
          </CheckAccess>
        ),
      },

      // FinSadaad
      {
        path: "fin-sadaad",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinSadaad />
          </CheckAccess>
        ),
      },

      // passPort
      {
        path: "fin-passport-renewal",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinPassportRenewal />
          </CheckAccess>
        ),
      },
      {
        path: "fin-driving-licence",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinDrivingLicence />
          </CheckAccess>
        ),
      },
      {
        path: "fin-ajeer",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinAjeer />
          </CheckAccess>
        ),
      },
      {
        path: "fin-baladiya",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinBaladiya />
          </CheckAccess>
        ),
      },
      {
        path: "gr-Ajeer",
        element: (
          <CheckAccess module="Client" name="client-list">
            <GRAjeer />
          </CheckAccess>
        ),
      },

      // OPS2 WORKFLOW

      {
        path: "dependent-master",
        element: (
          <CheckAccess module="Client" name="client-list">
            <DependentMaster />
          </CheckAccess>
        ),
      },
      // {
      //   path: "insurance-dependent",
      //   element: (
      //     <CheckAccess module="Client" name="client-list">
      //       <InsuranceDependent />
      //     </CheckAccess>
      //   ),
      // },

      {
        path: "dependent-addition",
        element: <Dependentaddition_OPS2 />,
        children: [
          {
            path: "ops1",
            element: <DependentAddition_ops1 />,
          },
          {
            path: "ops1_edit",
            element: <Dependent_addition_ops1_Edit />,
          },
          {
            path: "edit_OPS2",
            element: <Dependent_Addition_Ops2_Edit />,
          },
          {
            path: "Fianace",
            element: <Finance_Dependent />,
          },
          {
            path: "Additional_apporval",
            element: <Addition_Apporval_edit />,
          },
        ],
      },
      {
        path: "dependent-addition_ops1",
        element: <OPS1_InsuranceDependent />,
      },

      {
        path: "dependent-payment",
        element: (
          <CheckAccess module="Client" name="client-list">
            <DependentPayment />
          </CheckAccess>
        ),
      },
      {
        path: "Apply_insurance",
        element: (
          <>
            <ApplyInsurance_InsuranceDependent />
          </>
        ),
      },
      // Mobilization
      {
        path: "mobilization",
        element: (
          <CheckAccess module="MOBILIZATION" name="mobilization-view">
            <Mobilization />
          </CheckAccess>
        ),
      },
      // DeMobilization
      {
        path: "demobilization",
        element: (
          <CheckAccess module="DEMOBILIZATION" name="active-view">
            <Demobilization />
          </CheckAccess>
        ),
      },

      //Remobilization
      {
        path: "remobilization",
        element: (
          <CheckAccess module="REMOBILIZAITON" name="remobilizaiton-view">
            <Remobilization />
          </CheckAccess>
        ),
      },
      {
        path: "finance-demobilization",
        element: (
          <CheckAccess module="Client" name="client-list">
            <Financedemobilize />
          </CheckAccess>
        ),
      },
      {
        path: "final-exit",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinalExit />
          </CheckAccess>
        ),
      },
      {
        path: "final-exit/details/:employeeID",
        element: (
          <CheckAccess module="Client" name="client-list">
            <FinalExit />
          </CheckAccess>
        ),
      },
      {
        path: "settlement-preview/*",
        element: (
          <CheckAccess module="Client" name="client-list">
            <LocalFinalExit />
          </CheckAccess>
        ),
      },
    ],
  },
];

export default dashboardRoutes;
